import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1270.776,60 L1101.096,229.68 L1441.536,570.12 L1037.616,570.12 C465.456,570.12 -0.024,1035.6 -0.024,1607.76 L-0.024,1770.12 L239.976,1770.12 L239.976,1607.76 C239.976,1167.96 597.936,810.12 1037.616,810.12 L1452.096,810.12 L1101.096,1161.24 L1270.776,1330.92 L1906.176,695.4 L1270.776,60 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconForwardSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconForwardSolid, _Component);

  var _super = _createSuper(IconForwardSolid);

  function IconForwardSolid() {
    _classCallCheck(this, IconForwardSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconForwardSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconForward",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconForwardSolid.displayName = "IconForwardSolid";
  return IconForwardSolid;
}(Component);

IconForwardSolid.glyphName = 'forward';
IconForwardSolid.variant = 'Solid';
IconForwardSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconForwardSolid;
export { IconForwardSolid };